import React  from "react";
import { useIntl } from "react-intl";
import { Box } from "@material-ui/core";

import useTabStyles from "../../styles/Tab.style";
import { PageTitle } from "../../../../components/page-title/PageTitle";
import {AdminUsersTabPanel} from "../../tab-panels/admin-users/AdminUsersTabPanel";
import useStyles from "./AdminUsersTab.style";

interface AdminUsersTabProps {}

export const AdminUsersTab = (props: AdminUsersTabProps) => {
  const tabClasses = useTabStyles(props);
    const classes = useStyles(props);
  const intl = useIntl();

  return (
    <>
      <PageTitle
        withAppTitle={false}
        title={`${intl.formatMessage({
          id: "sharedScreen.admin",
        })} - ${intl.formatMessage({
          id: "sharedScreen.users",
        })}`}
      />
      <Box className={tabClasses.root}>
        <Box className={classes.rootContent}>
            <AdminUsersTabPanel />
        </Box>
      </Box>
    </>
  );
};
